<template>
  <div class="flex flex-col justify-between">
    <div class="w-full bg-b2c-grey-100 text-black text-center
     tracking-widest py-6 text-md mb-2 flex flex-col">
      <span class="font-medium">
        {{ $t('product.onRequestAreYouSending') }}
      </span>
      <span class="font-bold pt-6"> {{ product.description}} </span>
      <div class="flex items-center justify-center relative w-full pt-2" v-if="!edit">
        <span> {{ $t('product.quantity') }} {{ quantity }} </span>
        <button class="absolute right-1 hover:text-b2c-red-300" @click="edit=true">
          <edit-icon />
        </button>

      </div>
      <div v-else class="flex justify-center items-center pt-2 w-full">
        <span> {{ $t('product.quantity') }} </span>
        <input v-model="quantity" class="ml-2 pl-2 w-1/6 outline-none">
        <button class="ml-4 hover:text-b2c-red-300" @click="edit=false">
          <check-icon />
        </button>
      </div>
      <span class="pt-2"> {{ $t('product.price') }}: {{formatter.format(price)}}</span>
    </div>
    <div class="flex flex-row justify-between my-2 text-sm w-2/3 mx-auto">
        <button
          @click="$emit('close')"
          class="px-4 py-3 rounded border bg-b2c-red-300 border-b2c-red-300 w-32
          hover:bg-white text-white hover:text-b2c-red-300 uppercase cursor-pointer mb-3">
            {{$t('addresses.cancel')}}
        </button>
        <button
          @click="sendRequest"
          class="px-4 py-3 rounded border  bg-b2c-red-300 border-b2c-red-300 w-32
          hover:bg-white text-white hover:text-b2c-red-300 uppercase cursor-pointer mb-3"
          :class="isLoading ? 'loader' : ''">
            {{ $t('contacts.send') }}
      </button>
    </div>
  </div>
</template>

<script>
import { sendProductRequestByMail } from '@/services/ProductService';
import EditIcon from './EditIcon.vue';
import CheckIcon from './CheckIcon.vue';

export default {
  components: { EditIcon, CheckIcon },
  props: ['product'],

  data() {
    return {
      quantity: 1,

      edit: false,
      isLoading: false,
    };
  },

  computed: {
    price() {
      return ((this.product.price_with_vat * this.quantity) / 100);
    },
  },

  methods: {
    sendRequest() {
      this.isLoading = true;
      sendProductRequestByMail(this.product.id, this.quantity).then(() => {
        this.isLoading = false;
        this.$emit('close');
        this.createNotification('success', `${this.$t('notifications.onRequestEmail')} ${this.product.description}`);
      }).catch(() => {
        this.isLoading = false;
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  color: transparent !important;
  pointer-events: none;
  position: relative;
}

.loader:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #dbdbdb;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
